import { getEntryProps } from '../utils/getEntryProps.js';
import { mapSettingNavLink, mapEntryLink } from './navlink.js';
const mapNavbarProps = navbarEntry => {
  const _getEntryProps = getEntryProps(navbarEntry, {}),
    logoNavLink = _getEntryProps.logoNavLink,
    navLinks = _getEntryProps.navLinks,
    primaryCta = _getEntryProps.primaryCta,
    secondaryCta = _getEntryProps.secondaryCta;
  const mappedNavbarLinks = navLinks?.map(entry => {
    const entryProps = getEntryProps(entry);
    if (entryProps.label) {
      const singleNavLink = entryProps;
      return {
        label: singleNavLink.label,
        url: singleNavLink.url
      };
    }
    const linkGroup = entryProps;
    return {
      label: linkGroup.category,
      trapdoorLinks: linkGroup.links?.map(mapSettingNavLink),
      productLink: linkGroup.categoryLink ? mapSettingNavLink(linkGroup.categoryLink) : undefined
    };
  });
  const logoProps = logoNavLink && mapEntryLink(logoNavLink);
  const mainCtaProps = primaryCta && mapEntryLink(primaryCta);
  const secondaryCtaProps = secondaryCta && mapEntryLink(secondaryCta);
  return {
    primaryLogoTitle: logoProps?.label,
    primaryLogoHref: logoProps?.url,
    navLinks: mappedNavbarLinks || [],
    secondaryCtaLabel: secondaryCtaProps?.label,
    secondaryCtaUrl: secondaryCtaProps?.url,
    primaryCtaLabel: mainCtaProps?.label,
    primaryCtaUrl: mainCtaProps?.url
  };
};

// TODO: temporary mapping until we redefine our theme variables in Contentful, and navbar only supports default and dark for now
const navbarThemeMap = {
  Default: 'default',
  Blue: 'default',
  Dark: 'dark',
  Light: 'default'
};
export { mapNavbarProps, navbarThemeMap };
//# sourceMappingURL=navbar.js.map
